import { Tab } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import SubTabList from "./SubTabList";

const TabList = ({ listItems, expandedParent = () => {} }) => {
  const [expandedParentIndex, setExpandedParentIndex] = useState(null);

  useEffect(() => {
    expandedParent(expandedParentIndex);
  }, [expandedParentIndex]);

  return (
    <Tab.List className="flex flex-col gap-1 text-REELTeal-300 text-body-lg font-medium">
      {listItems.map((item, index) => (
        <Fragment key={index}>
          {item.children ? (
            // Parent Tab with Chevron Toggle
            <div>
              <div
                className={`cursor-pointer flex items-center py-4 pl-2 text-teal-300 ${
                  expandedParentIndex === index
                    ? "bg-gray-20"
                    : "hover:bg-gray-20"
                }`}
                onClick={() =>
                  setExpandedParentIndex(
                    expandedParentIndex === index ? null : index
                  )
                }
              >
                <ChevronDownIcon
                  className={`w-4 h-4 ${
                    expandedParentIndex === index ? "-rotate-180" : ""
                  }`}
                />
                <span className="pl-2">{item.name}</span>
              </div>
              {/* Render Children if Parent is Expanded */}
              {item.children && expandedParentIndex === index && (
                <SubTabList listItems={item.children} />
              )}
            </div>
          ) : (
            // Individual Tab
            <Tab as={Fragment}>
              {({ selected }) => (
                <button
                  className={`block py-4 pr-4 pl-8 text-left outline-none font-bold-md text-teal-300 ${
                    selected
                      ? "bg-teal-25 border-l-4 border-REELTeal"
                      : item.disabled
                      ? "text-gray-200 cursor-not-allowed"
                      : "hover:bg-gray-20"
                  }`}
                >
                  {item.name}
                </button>
              )}
            </Tab>
          )}
        </Fragment>
      ))}
    </Tab.List>
  );
};

export default TabList;
